import { useAppDispatch } from 'state/store';
import {
  showFullLoadingView,
  showNoDataView,
  toggleCollapsablePanelCollapse,
  toggleSearchTreeCollapse,
  setSideBarCollapse,
  updateMeasureType,
} from 'state/store/reducers/uiSlice';

export type UseUiActions = {
  setShowFullLoadingView: (flag: boolean) => void;
  setShowNoDataView: (flag: boolean) => void;
  setMeasureType: (measureType: string) => void;
  toggleCollapsiblePanel: () => void;
  toggleSearchTree: () => void;
  setSideBarCollapsed: (collapsed: boolean) => void;
};

export const useUiActions = (): UseUiActions => {
  const dispatch = useAppDispatch();

  return {
    setShowFullLoadingView: (flag: boolean) => {
      dispatch(showFullLoadingView(flag));
    },

    setShowNoDataView: (flag: boolean) => {
      dispatch(showNoDataView(flag));
    },

    setMeasureType: (measureType: string) => {
      dispatch(updateMeasureType(measureType));
    },

    toggleCollapsiblePanel: () => {
      dispatch(toggleCollapsablePanelCollapse({}));
    },

    toggleSearchTree: () => {
      dispatch(toggleSearchTreeCollapse({}));
    },

    setSideBarCollapsed: (collapsed: boolean) =>
      dispatch(setSideBarCollapse(collapsed)),
  };
};
